import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #006DA3;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 501px;
  text-align: center;
`;
